import { render, staticRenderFns } from "./OtherSupplierDetailsTabs.vue?vue&type=template&id=46b9425f&"
import script from "./OtherSupplierDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./OtherSupplierDetailsTabs.vue?vue&type=style&index=0&id=46b9425f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports